import React, { useState } from 'react';
import { Button, ModalWindow, TooltipDesktop, Wait16 } from '@cian/ui-kit';
import loadable from '@loadable/component';

import { ControlWrapper } from '../../../../components/ControlWrapper';
import { Loader } from '../../../../components/Loader';

const ComplaintFormContainerLoadable = loadable.lib(() => import('../../ComplaintFormContainer'));

export function ComplainControlContainer() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <ControlWrapper>
        <TooltipDesktop theme="black" placement="left" title="Пожаловаться">
          <Button
            data-mark="ComplainControl"
            theme="stroke_secondary"
            onClick={() => setOpen(true)}
            size="XS"
            beforeIcon={<Wait16 />}
          />
        </TooltipDesktop>
      </ControlWrapper>
      <ModalWindow
        size="XS"
        width={600}
        fixed={false}
        open={open}
        onClose={() => setOpen(false)}
        content={
          <ComplaintFormContainerLoadable fallback={<Loader />}>
            {({ ComplaintFormContainer }) => <ComplaintFormContainer onClose={() => setOpen(false)} />}
          </ComplaintFormContainerLoadable>
        }
      />
    </>
  );
}
